import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx, _cache) {
  const _component_Popover = _resolveComponent("Popover")
  const _component_RadioButtonHorizontal = _resolveComponent("RadioButtonHorizontal")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["multi-radioboxes mt-4", _ctx.validForm() ? 'answered' : ''])
  }, [
    _createElementVNode("h4", null, [
      _createTextVNode(_toDisplayString(_ctx.newWording) + " ", 1),
      _createVNode(_component_Popover, { popover: _ctx.obj }, null, 8, ["popover"])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.question.atcsSubQuestions, (sq, i) => {
      return (_openBlock(), _createBlock(_component_RadioButtonHorizontal, {
        class: "ml-4 one-lineOptions",
        question: _ctx.question.atcsSubQuestions[i],
        "onUpdate:question": $event => ((_ctx.question.atcsSubQuestions[i]) = $event),
        onChanged: $event => (_ctx.onValueChanged($event, i)),
        onValidForm: $event => (_ctx.validationForm(i, $event))
      }, null, 8, ["question", "onUpdate:question", "onChanged", "onValidForm"]))
    }), 256))
  ], 2))
}